import {inlineError} from '@s-ui/decorators'

import {PageRepository} from './PageRepository.js'

/**
 * @class
 * @implements PageRepository
 */
export class HTTPPageRepository extends PageRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {Fetcher} deps.fetchOrFail
   * @param {Function} deps.getRemoteUrlErrorFactory
   * @param {Function} deps.urlValueObjectFactory
   */
  constructor({config, fetchOrFail, getRemoteUrlErrorFactory, urlValueObjectFactory}) {
    super()
    this._config = config
    this._fetchOrFail = fetchOrFail
    this._getRemoteUrlErrorFactory = getRemoteUrlErrorFactory
    this._urlValueObjectFactory = urlValueObjectFactory
  }

  @inlineError
  async getRemoteUrl({remoteUrlRequest}) {
    const {GENERIC} = this._config.get('COMMON').ERRORS
    const params = {items: remoteUrlRequest.getItems()}

    const url = `${this._config.get('API_URL')}/url-builder`

    const [error, response] = await this._fetchOrFail
      .withErrorsFactories({
        [GENERIC]: ({message}) => {
          return this._getRemoteUrlErrorFactory(message)
        }
      })
      .post(url, params)

    if (error) {
      return Promise.reject(this._getRemoteUrlErrorFactory(error))
    }

    const {data} = response

    return this._urlValueObjectFactory({url: data})
  }
}
